<template lang="pug">
    v-footer.footer.justify-center(fixed)
        div.text-center
            router-link(a to="/contact") {{ $t('footer.termsLink') }}
            span {{ ` / ` }}
            router-link(a to="/legal-information") {{ $t('footer.legalLink') }}

            div.mt-1 {{ $t('footer.message') }}
</template>

<script>
    export default {};
</script>

<style lang="stylus" scoped>
    @import '../assets/style/_variables.styl'

    .footer
        background: $gradient
        font-size: 12px

        *
          color: $theme.white !important
          opacity: 0.96
</style>
